import { css } from '@inter-ikea-kompis/web-component';
export default class CheckboxGroupStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color } = options.theme;
        return css `
			:host {
				display: block;
			}
			::slotted(kompis-checkbox) {
				margin-bottom: ${spacing.space150 / 16}rem;
			}
			.container {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
			}
			.heading {
				margin-bottom: ${spacing.space75 / 16}rem;
				color: ${color.text.dark};
			}
			.help {
				color: ${color.neutral.grey700};
			}
		`;
    }
}
//# sourceMappingURL=CheckboxGroupStyle.js.map